import api from '../services/api';

const url = 'documentos';

export const SHOW = async (id) => await api.get(`/${url}/${id}`).then(res => res.data);
export const SHOW_QCCERT = async (id) => await api.get(`/${url}/${id}/qccert`).then(res => res.data);
export const DELETE = async (id) => await api.delete(`/${url}/${id}`).then(res => res.data);
